/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import _ from 'underscore';

import Tags from 'components/Tags';
import * as selectables from 'molbio/maps/selectables/Selectables';
import pick from 'util/pick';

class Sequence extends Backbone.Model {
  static initClass() {
    this.prototype.urlRoot = '/1/api/sequences';
  }

  bases() {
    return this.get('bases');
  }
  folder() {
    return this.get('folder');
  }
}
Sequence.initClass();

class TagSequence extends selectables.Model {
  // Simpler sequence that just supports tag editing.
  defaults() {
    // eslint-disable-next-line no-restricted-syntax
    return _.extend(super.defaults(), {visible: true});
  }

  folder() {
    return this.get('_sequence').folder();
  }

  initialize() {
    this.set({tags: new Tags(this.get('_sequence').get('tags'), {sequenceID: this.id})});
  }

  parse(data) {
    const ret = pick(data, 'id', 'status');
    ret._sequence = new Sequence(data, {parse: true});
    return ret;
  }
}

export default TagSequence;
